export default {
  changes: {
    // Change types
    typeNewEntry: "New entry",
    typePriceChange: "Price change",
    typeReimbursementChange: "Reimbursement",
    typeExclusion: "Exclusion",
    typeDeduction: "Deduction",
    typeWarning: "Notice",
    typeMarketingStatus: "Market status",
    typeEuRegistration: "EU registration",
    typeExclusivity: "Exclusivity",
    colSource: "Source",
    exporting: "Exporting…",
    emaAuthorised: "Authorised",
    emaApplicationWithdrawn: "Application withdrawn",
    emaWithdrawn: "Withdrawn",
    emaRefused: "Refused",

    // Team marks
    star: "Star",
    unstar: "Remove star",
    markReviewed: "Mark as reviewed",
    reviewedBy: "Reviewed by {who}",
    theTeam: "the team",
    addTeamNote: "Add team note",
    noteFrom: "Note from {who}: {note}",
    team: "team",
    notePlaceholder: "Note visible to your whole team…",
    lastEdit: "Last edited by: {who}",
    close: "Close",
    save: "Save",

    // Header
    title: "Detected events",
    subtitle: "Price, reimbursement, authorisation and safety events across your portfolio and your competitors.",
    regulatoryPrefix: "Regulatory events are in the ",
    regulatoryRadar: "Regulatory Radar ↗",
    exportExcel: "Export to Excel",
    exportCsv: "CSV",

    // Active filters
    clearFilter: "Clear filter",

    // Filters
    searchPlaceholder: "Search product, CN, active substance, laboratory…",
    // C-14 consolidation (§90 phase 1C)
    consolidate: "Group confirmations",
    consolidateHint: "The same fact published by several sources is shown once, with the number of sources confirming it",
    confirmedBy: "Confirmed by {n} sources: {sources}",
    originDoc: "Open the document that originated this event (BOE, CIPM, official note…)",
    originDocShort: "document",
    candidate: "Possible match",
    candidateConfirmed: "Match confirmed",
    candidateDiscarded: "Discarded",
    confirm: "Confirm",
    discard: "Discard",
    undo: "Undo",
    pendingCandidates: "Possible matches to review",
    discardedCandidates: "Discarded matches",
    resolvedOn: "Resolved on {date}",
    allTypes: "All types",
    allSources: "All sources",
    myLabAndCompetition: "My laboratory + competition",
    onlyOrg: "Only {org}",
    onlyCompetition: "Only competition",
    allMarket: "Whole market",
    allPriority: "All priorities",
    priorityHigh: "High — your portfolio",
    priorityMedium: "Medium — your competition",
    priorityLow: "Low — rest",
    allMarks: "All marks",
    starred: "Starred",
    pendingReview: "Pending review",
    reviewed: "Reviewed",
    withNote: "With note",

    // Table headers
    colMarks: "Marks",
    colDate: "Date",
    colPrio: "Prio.",
    colType: "Type",
    colProduct: "Product",
    colActiveIngredient: "Active Substance",
    colCurrentPrice: "Current Price",
    colPreviousPrice: "Previous Price",
    colDeduction: "Deduction",
    colCn: "CN",
    colLabel: "Ownership",
    colLaboratory: "Laboratory",

    // States
    loading: "Loading…",
    noResults: "No results",
    viewProduct: "View {name} details",
    viewAllChangesOf: "View all events for {lab}",

    // Portfolio labels
    competitor: "Competitor",
    others: "Others",

    // Pagination
    pageOf: "Page {page} of {total}",
    recordsFound: "{total} records found",
  },
};
